export var PaymentCardTestId;
(function (PaymentCardTestId) {
    PaymentCardTestId["ContactSupport"] = "PaymentCardContactSupport";
    PaymentCardTestId["Container"] = "PaymentCardContainer";
    PaymentCardTestId["Header"] = "PaymentCardHeader";
    PaymentCardTestId["SavedCards"] = "PaymentCardSavedCards";
    PaymentCardTestId["ListCell"] = "PaymentCardListCell";
    PaymentCardTestId["ActionButton"] = "PaymentCardActionButton";
    PaymentCardTestId["ActionMenu"] = "PaymentCardActionMenu";
    PaymentCardTestId["DeleteCardButton"] = "PaymentCardDeleteCardButton";
    PaymentCardTestId["SetDefaultCardButton"] = "PaymentCardSetDefaultCardButton";
    PaymentCardTestId["DeleteConfirmationModalCancelButton"] = "DeleteConfirmationModalCancelButton";
    PaymentCardTestId["DeleteConfirmationModalDeleteButton"] = "DeleteConfirmationModalDeleteButton";
    PaymentCardTestId["PaymentCardAdd"] = "PaymentCardAdd";
    PaymentCardTestId["AddCardModalSaveButton"] = "AddCardModalSaveButton";
    PaymentCardTestId["AddCardModalCancelButton"] = "AddCardModalCancelButton";
})(PaymentCardTestId || (PaymentCardTestId = {}));
